<template>
  <v-container v-if="isLoaded">
    <v-card>
      <v-card-title>
        View geographical countries
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          id="geographicalCountrySearchInput"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="_headers"
        :items="geographicalCountries"
        :items-per-page="50"
        :search="search">
        <template v-slot:item.refresh="{ item }">
          <v-btn icon @click="refresh(item)">
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <base-dialog-ok
        label="Entity has been refresh!"
        :dialog="refreshDialog"
        @ok="() => refreshDialog = false"/>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseDialogOk from '@/base/dialog/BaseDialogOk'
import axios from 'axios'
import { security } from '@/mixins/utilsMixin'

export default {
  name: 'ViewGeographicalCountry',
  components: { BaseDialogOk },
  mixins: [security],
  data () {
    return {
      isLoaded: false,
      search: '',
      refreshDialog: false,
      tableHeaders: [
        { text: 'SdsId', align: 'start', sortable: true, value: 'sdsId' },
        { text: 'Code', sortable: true, value: 'code' },
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Refresh', align: 'start', sortable: false, value: 'refresh' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'geographicalCountries',
      'getUserRoles'
    ]),
    _headers () {
      if (!this.isTechAdmin(this.getUserRoles)) {
        return this.tableHeaders.filter(header => header.text !== 'Refresh')
      }
      return this.tableHeaders
    }
  },
  async mounted () {
    await this.$store.dispatch('getAllGeographicalCountries').then(() => { this.isLoaded = true })
  },
  methods: {
    refresh (item) {
      return axios.get('/api/touchpoint/geographicalCountry/refresh/' + item.sdsId)
        .then(response => {
          const index = this.geographicalCountries.findIndex(pm => pm.id === response.data.id)
          this.geographicalCountries.splice(index, 1, response.data)
          this.refreshDialog = true
        })
        .catch(e => console.log(e))
    }
  }
}
</script>

<style scoped>

</style>
